import React, { useEffect, useMemo, useRef, useState } from 'react'
import { enumUtil } from '../../../../../../../../utils/Enum';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import DropdownValueHandler from '../../../../../../../shared/SuperSearch/DropdownValueHandler';
import EncounterDetails from '../EncounterDetails/EncounterDetails';
import isNull from '../../../../../../../../utils/NullChecking';
import ReloadGridAction from '../../../../../../../../actions/ReloadGridAction';
import { ServerRequestProtected } from '../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
import SectionScrollNavigator from './Components/SectionScrollNavigator';
import Loader from '../../../../../../../shared/Loader/Loader';
import FormValidator from '../../../../../../../../utils/FormValidator';
import { encounterStatus } from '../Components/Constants';
import CustomNote from './CustomNote';
import { FindFirstChild } from '../../../../../../../../utils/FindMenuOption';
import { Modal } from "react-bootstrap";
import ModalHeader from '../../../../../../../Setup/Shared/ModalHeader';
import { getNoteDisplaySettings } from '../Components/utils';
import { Separator } from '../../../../../../../EHR/utils/utils';
import useCustomTemplateItemsValidation from '../Components/Custom Template Form/Components/useCustomTemplateItemsValidation';

const CustomNotewithDetails = ({ templateDataToApply, setTemplateDataToApply, ...props }) => {
    let { patientID, encounterID } = props;
    let isEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd;
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    const visitTypes = useSelector(state => state.GeneralDropDownsReducer.EncounterType);
    console.log("propsCustomNotewithDetails", props)
    const hasInitializedAIProcessing = useRef(false);
    const SearchCriteria = {
        "EncounterType": "",
        "NoteType": "CustomNote",
        "EncounterDate": "",
        "SeenBy": "",
        "Facility": "",
        "EncounterStatus": "In Progress",
        "VitalUnitType": "US Customary",
        "PatientAppointmentID": ""
    }
    const [searchParam, setSearchParam] = useState(SearchCriteria);
    const encounterNotesDisplay = useSelector(state => state?.EncounterNotesDisplaySettingsReducer);

    const DEFAULT_PREVIEW_SELECTED = {
        ...encounterNotesDisplay
    }
    const [defaultSelectedItems, setDefaultSelectedItems] = useState(DEFAULT_PREVIEW_SELECTED);
    const [selectedItems, setSelectedItems] = useState(DEFAULT_PREVIEW_SELECTED);
    const encounterNotesDisplaySetting = useMemo(() => {
        if (!encounterNotesDisplay || !(encounterNotesDisplay?.length > 0)) {
            return {};
        }

        return getNoteDisplaySettings(encounterNotesDisplay, searchParam?.SeenBy, searchParam?.NoteType);
    }, [encounterNotesDisplay, searchParam?.SeenBy, searchParam?.NoteType]);

    useEffect(() => {
        if (!encounterNotesDisplaySetting) return;
        if (!encounterNotesDisplaySetting || Object.keys(encounterNotesDisplaySetting).length === 0) {
        } else {
            setDefaultSelectedItems(encounterNotesDisplaySetting)
            setSelectedItems(encounterNotesDisplaySetting);
        }
    }, [encounterNotesDisplaySetting])

    // let {searchParam, setSearchParam, SearchCriteria} = props;
    let providerDD = useSelector(state => state.GeneralDropDownsReducer.Provider);
    let locationDD = useSelector(state => state.GeneralDropDownsReducer.Location);

    let dispatch = useDispatch();
    const scrollableDivRef = useRef(null);
    const scrollIntervalRef = useRef(null);
    const API_URL = enumUtil.controller.PatientEncounter;
    // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;
    // let EncounterIDR =
    //     useSelector(state =>
    //         state.Open_Patient_Tab?.find((pt) => pt.active === true)
    //             ?.Open_Encounter_Tab?.find((pt) => pt.active === true)
    //             ?.data?.id
    //     );
    ///////////////// Custom Import Form //////////////////////
    const { validationItemsModalMain, handleSetDefaultItemsForValidationMain } = useCustomTemplateItemsValidation();
    const [mainCustomTemplateData, setMainCustomTemplateData] = useState([]);
    const [saveMainCustomTemplateData, setSaveMainCustomTemplateData] = useState([]);
    ///////////////// Custom Main Import Form //////////////////////
    const { validationItemsModal, handleSetDefaultItemsForValidation } = useCustomTemplateItemsValidation();
    const [customTemplateData, setCustomTemplateData] = useState([]);
    const [saveCustomTemplateData, setSaveCustomTemplateData] = useState([]);
    ///////////////////////////////////////////////////////////
    const [mainServiceLineModal, setMainServiceLineModal] = useState([]);
    const [encounterExistConfirmation, setEncounterExistConfirmation] = useState(false);
    const [saveAddendumData, setSaveAddendumData] = useState([]);
    const [saveQualityOfCareData, setSaveQualityOfCareData] = useState({
        "QualityOfCareID": "",
    });
    const [reloadAfterSave, setReloadAfterSave] = useState(false);
    const [activeID, setActiveID] = useState(null);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [saveEncounterCoSignData, setSaveEncounterCoSignData] = useState([]);
    const [clinicalAINoteJobsID, setClinicalAINoteJobsID] = useState(null);

    let ITEM_DATA = [
        {
            "EHRComponentItemID": "",
            "EHRComponentID": "",
            "ItemID": "Notes-0",
            "name": "Notes",
            "content": "Chief Complaint",
            "options": null,
            "selectedOptions": null,
            "MultiLineAnswer": null,
            "answer": null,
            "noOfHeaders": null,
            "isDeleted": "false",
            "order": "0",
            "noOfRows": null,
            "headers": null,
            "rows": null,
            "file": null
        },
        {
            "EHRComponentItemID": "",
            "EHRComponentID": "",
            "ItemID": "Notes-1",
            "name": "Notes",
            "content": "Notes",
            "options": null,
            "selectedOptions": null,
            "MultiLineAnswer": null,
            "answer": null,
            "noOfHeaders": null,
            "isDeleted": "false",
            "order": "1",
            "noOfRows": null,
            "headers": null,
            "rows": null,
            "file": null
        }
    ];
    ////////////// Maybe its the apply Repeat Past Encounters /////////////////
    // const DEFAULT_TEMPLATE_DATA = {
    //     EHRTemplateID: "",
    //     TemplateName: "CustomNote",
    //     TemplateType: "CustomNote",
    //     Data: [
    //         {
    //             "EHRTemplateID": "",
    //             "key": "SUBJECTIVE",
    //             "type": "Component-Based",
    //             "items": ITEM_DATA
    //         },
    //         {
    //             "EHRTemplateID": "",
    //             "key": "OBJECTIVE",
    //             "type": "Component-Based",
    //             "items": ITEM_DATA
    //         },
    //         {
    //             "EHRTemplateID": "",
    //             "key": "RESPONSE",
    //             "type": "Component-Based",
    //             "items": ITEM_DATA
    //         },
    //         {
    //             "EHRTemplateID": "",
    //             "key": "PLAN",
    //             "type": "Component-Based",
    //             "items": ITEM_DATA
    //         },
    //         {
    //             "EHRTemplateID": "",
    //             "key": "NOTES",
    //             "type": "Component-Based",
    //             "items": ITEM_DATA
    //         }
    //     ]
    // }
    // const [templateData, setTemplateData] = useState(DEFAULT_TEMPLATE_DATA);
    ///////////////////////////////////////////////////////////////////////////

    const [showPreview, setShowPreview] = useState(false);
    const [printoutSelectDataModal, setPrintoutSelectDataModal] = useState(false);
    const [printoutModal, setPrintoutModal] = useState(false);

    let ACCORD_DATA = [
        { active: true, key: 'SUBJECTIVE', type: 'Component-Based' },
        { active: true, key: 'OBJECTIVE', type: 'Component-Based' },
        { active: true, key: 'RESPONSE', type: 'Component-Based' },
        { active: true, key: 'PLAN', type: 'Component-Based' },
        { active: true, key: 'AdditionalINFO', type: 'Component-Based' },
    ]
    const [accordions, setAccordions] = useState(ACCORD_DATA);

    const SearchCriteriaName = {
        "EncounterType": "",
        "NoteType": "Other Note",
        "SeenBy": "",
        "Facility": "",
        "EncounterStatus": "In Progress",
    }
    const [searchValue, setSearchValue] = useState(SearchCriteriaName)
    let ENCOUNTER_DEFAULT_MODEL = {
        "TableName": enumUtil.enumAPITableName.CustomNote,
        "Data": {
            "EncounterID": "",
            "PatientID": patientID || "",
            "EncounterType": "",
            "NoteType": "",
            "EncounterDate": format(new Date(), 'MM/dd/yyyy'),
            "SeenBy": "",
            "Facility": "",
            "EncounterStatus": "",
            "VitalUnitType": "US Customary",
            "ChiefComplaint": "",
            "SubjectiveNotes": "",
            "ObjectiveNotes": "",
            "AssesmentNotes": "",
            "PlanNotes": "",
            "AdditionalInfoNotes": ""
        },
        "Vital": [],
        "EncounterProblem": [],
        "EncounterDocument": [],
        "EncounterAddendum": [],
        "QualityOfCare": {},
        "SuperBill": [],
        "CognitiveStatus": [],
        "FunctionalStatus": [],
    }

    const [is, setIs] = useState(true);
    const [encounterData, setEncounterData] = useState(ENCOUNTER_DEFAULT_MODEL);
    const customNoteType = encounterData?.Data?.NoteType;

    console.log("CustomNote12345", customNoteType)

    const [appointmentData, setAppointmentData] = useState([])
    const API_URL_General = enumUtil.controller.General
    // const [encounterID, setEncounterID] = useState('');
    // const [patientID, setPatientID] = useState('');
    useEffect(() => {
        // setEncounterID(EncounterIDR);
        // setPatientID(PatientIDR);
        ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": patientID,
        })
            .then((response) => {
                setAppointmentData(response)
            }).catch((error) => {
            })
    }, [])

    const startScrolling = (direction) => {
        if (!scrollableDivRef.current) return;

        // Start the interval for scrolling
        scrollIntervalRef.current = setInterval(() => {
            scrollableDivRef.current.scrollBy({
                top: direction === "down" ? 10 : -10, // Scroll 10px at a time
            });
        }, 16); // Repeat every 1ms
    };

    const stopScrolling = () => {
        // Clear the interval to stop scrolling
        if (scrollIntervalRef.current) {
            clearInterval(scrollIntervalRef.current);
            scrollIntervalRef.current = null;
        }
    };
    ///////////////////////////////////////////////////
    useEffect(() => {
        if (templateDataToApply?.key) {
            let accordExist = accordions?.map(it => it.key).includes(templateDataToApply?.key);

            // setTemplateData(prev => {
            //     return {
            //         ...prev,
            //         Data: accordExist ?
            //             (prev?.Data?.map(accord =>
            //                 accord.key === templateDataToApply.key ?
            //                     {
            //                         ...accord,
            //                         items: [
            //                             ...accord.items,
            //                             ...templateDataToApply.items.filter(
            //                                 item =>
            //                                     !accord.items.some(
            //                                         it => it.EHRComponentItemID === item.EHRComponentItemID
            //                                     )
            //                             ),
            //                         ],
            //                     } : accord)) : [...prev?.Data, templateDataToApply]
            //     }
            // });
            let { key, type } = templateDataToApply;
            setAccordions(prev => accordExist ? prev : [...prev, { active: true, key, type }])
            setTemplateDataToApply({});
        }
    }, [templateDataToApply])

    useEffect(() => {
        if (!isNull(props.Reload) && encounterID && !['-1', -1, 0, ""].includes(encounterID)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 218) {
                    LoadData()
                }
            })
            if (data.length === 0) {
                LoadData()
            }
        }
    }, [props.Reload, encounterID]);

    useEffect(() => {
        if (!reloadAfterSave) return;
        LoadData();
    }, [reloadAfterSave])

    let SAVE_TRIGGER_MODEL = {
        'CustomNote': false,
    };
    const [saveTrigger, setSaveTrigger] = useState(SAVE_TRIGGER_MODEL);
    const [saveModal, setSaveModel] = useState({});
    // const handleEditSuperbill = () => {
    //     let element = document?.getElementById(`SuperBill-${encounterData?.Data?.EncounterID}`)
    //     console.log("handleEditSuperbill", element)
    //     if (element) {
    //         element.scrollIntoView({ behavior: 'smooth' });
    //         setIsProcedureEdit(true);
    //     }
    // }

    const getSaveData = async () => {
        if (!isEditAllowed) return;
        const valModal = await childRef.current?.EncounterDetailsValidation(); // call child's validate
        let validationEncDetails = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);

        const valCustomNoteIsNotValid = await childCustomNoteRef.current?.CPTValidation(); // call child's validate
        console.log("validationCustomNotevalCustomNoteExists", validationEncDetails, valCustomNoteIsNotValid)

        if (validationEncDetails || valCustomNoteIsNotValid) {
            if (valCustomNoteIsNotValid) {
                // handleEditSuperbill();
                NotificationHandler('Pointer validation error occurred.', enumUtil.enumtoaster.error);
            }
            setSaveTrigger(SAVE_TRIGGER_MODEL)
            return
        } else {
            setSaveTrigger(
                { [searchParam.NoteType]: true },
            );
        }
    }

    const onSave = (type, val) => {
        setSaveModel(prev => ({ ...prev, [type]: val }));
        setSaveTrigger(prev => ({ ...prev, [type]: "callSave" }));
    }

    console.log('mainCustomTemplateData', mainCustomTemplateData);

    const getSaveModel = () => {
        // if (searchParam.NoteType === "SOAP") {
        //     return saveModal.SOAP;
        // }

        if (searchParam.NoteType === customNoteType) {
            return saveModal?.[customNoteType || 'CustomNote'];
        }
    }
    const handleSave = (updatedParams) => {
        setIsLoading(true)
        console.log("handleSave")
        let saveData = getSaveModel();
        if (updatedParams?.SaveDuplicateEncounter === "true") {
            saveData.Data.SaveDuplicateEncounter = updatedParams.SaveDuplicateEncounter;
        }
        // console.log(" handleEncounterExists updatedParams saveData", saveData, updatedParams);

        if (clinicalAINoteJobsID) {
            saveData.Data.ClinicalAINoteJobsID = clinicalAINoteJobsID;
        }
        ServerRequestProtected(API_URL + "/SaveCustomNote", 'post', {
            ...saveData
        })
            .then((response) => {
                setIsLoading(false);
                NotificationHandler('Record Saved Successfully', enumUtil.enumtoaster.success);
                let newObj = {
                    key: 2,
                    name: "Encounter",
                    active: true,
                    data: {
                        id: response.id,
                        name: searchParam.EncounterDate,
                        time: new Date(),
                    },
                };
                dispatch({
                    type: 'Open_New_Encounter_Tab',
                    payload: {
                        patientId: patientID,
                        encounterId: encounterID,
                        newObj: newObj
                    }
                });

                // }
                setReloadAfterSave(true);
                dispatch(ReloadGridAction({ EncounterSearch: true }));
            }).catch((error) => {
                setIsLoading(false)
                console.log("Error Error", error?.response?.data)
                if (error?.response?.data === "An encounter already exists for the selected date") {
                    handleEncounterExists(saveData.Data.EncounterDate);
                } else {
                    error?.response?.data && NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
                }
            })
    }

    useEffect(() => {
        const callSave = Object.values(saveTrigger).every(val => val === "callSave");
        console.log("callSave", saveTrigger, callSave)
        if (callSave) {
            handleSave();
            setSaveTrigger(SAVE_TRIGGER_MODEL); // reset after save
        }
    }, [saveTrigger])

    const LoadData = () => {
        if (['-1', -1, 0, ""].includes(encounterID)) return;
        setSearchParam(SearchCriteria);
        setSearchValue(SearchCriteriaName);
        setEncounterData(ENCOUNTER_DEFAULT_MODEL);
        setSaveMainCustomTemplateData([]); // reset Main Save on reload
        setSaveCustomTemplateData([]); // reset Save on reload
        setSaveEncounterCoSignData([]);
        setShowPreview(false);
        setIsLoading(true);
        setReloadAfterSave(false);
        setClinicalAINoteJobsID(null);
        ServerRequestProtected(API_URL + "/GetCustomNote", 'post', {
            "TableName": enumUtil.enumAPITableName.CustomNote,
            "ID": encounterID,
        })
            .then((response) => {
                setIsLoading(false);
                setSearchParam(prev => ({
                    ...prev,
                    "EncounterType": response?.Data?.EncounterType,
                    "NoteType": response?.Data?.NoteType,
                    "EncounterDate": response?.Data?.EncounterDate,
                    "SeenBy": response?.Data?.SeenBy,
                    "Facility": response?.Data?.Facility,
                    "EncounterStatus": response?.Data?.EncounterStatus,
                    "VitalUnitType": response?.Data?.VitalUnitType,
                    "PatientAppointmentID": response?.Data?.PatientAppointmentID,
                }));
                setEncounterData(prev => ({
                    ...prev,
                    ...response,
                    Data: { ...prev?.Data, ...response?.Data }
                }));
                setMainCustomTemplateData(response?.MainCustomTemplate || [])
                setCustomTemplateData(response?.CustomTemplate || [])
                let { TableName, ...qocData } = response.QualityOfCare;
                setSaveQualityOfCareData(prev => ({ ...prev, ...qocData }));

                setShowPreview(["Signed", "To Be Co-Signed"].includes(response?.Data?.EncounterStatus) || !isEditAllowed);
                setSearchValue(prev => ({
                    ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, response?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, response?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, response?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, response?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, response?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": response?.Data?.PatientAppointmentID ? response?.Data?.EncounterDate : "",
                }));
                setSaveTrigger({ [response?.Data?.NoteType || 'CustomNote']: false })
                setIsProcedureEdit(response?.SuperBill?.length > 0 ? false : true)
                setIs(true);
            }).catch((error) => {
                setIsLoading(false)
            })
    }

    const [isProcedureEdit, setIsProcedureEdit] = useState(false);
    const childRef = useRef();
    const childCustomNoteRef = useRef();

    const confirmationMsg = (EncounterDate) => {
        return new Promise((resolve, reject) => {
            const handleConfirmation = (userConfirmed) => {
                if (userConfirmed) {
                    resolve(userConfirmed);
                } else { reject(userConfirmed); }
                setEncounterExistConfirmation(<></>);
            };
            setEncounterExistConfirmation(
                <Modal show={true} onHide={() => handleConfirmation(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group ">
                    <ModalHeader HeaderName={Heading} DeletePopup={""} isClosed={() => handleConfirmation(false)} key={6331} Name={'DuplicateEncounter'} />
                    <Modal.Body>
                        <div className='ar-alert d-flex mb-12'>
                            <i className='icon-Vector13 mt-1'></i>
                            <div>
                                <p className='text ms-1'>Encounter already exists for {EncounterDate}. Do you want to create another encounter?</p>
                            </div>
                        </div>
                    </Modal.Body>

                    <div className="modal_footer za_br_light br-top-1 pt-2 ">
                        <div className='za-button text-end d-flex justify-content-end gap-2'>
                            <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={() => handleConfirmation(false)}>No</button>
                            <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => handleConfirmation(true)}>Yes</button>
                        </div>
                    </div>
                </Modal>)
        })
    }

    const Heading = () => {
        return <p className='heading Rejected_clr'>Confirmation Message</p>;
    };

    const handleEncounterExists = async (EncounterDate) => {
        const userConfirmed = await confirmationMsg(EncounterDate);
        console.log("handleEncounterExists", userConfirmed);
        if (userConfirmed) {
            let updatedParams = { ...searchParam, SaveDuplicateEncounter: "true" };
            setSearchParam(() => updatedParams);
            handleSave(updatedParams);
        }
    }
    const insertPosition = customTemplateData?.[0]?.InsertPosition || '';
    console.log("CustomTemplateForm123 insertPosition", insertPosition)
    const [aiEncounterData, setAIEncounterData] = useState(null)

    const mergeItemsById = (prevItems = [], newItems = []) => {
        if (!newItems?.length) return prevItems;

        const merged = prevItems.map(prevItem => {
            const match = newItems.find(newItem => newItem.ItemID === prevItem.ItemID);
            return match ? match : prevItem; // replace if present in new, else keep old
        });

        // append any item that's new (wasn't in main/ prev at all)
        // newItems.forEach(newItem => {
        //     if (!merged.some(m => m.ItemID === newItem.ItemID)) {
        //         merged.push(newItem);
        //     }
        // });

        return merged;
    };
    const mergeMainCustomTemplate = (prevTemplates = [], newTemplates = []) => {
        if (!newTemplates?.length) return prevTemplates;
        if (!prevTemplates?.length) return newTemplates;

        const prevTpl = prevTemplates[0];
        const newTpl = newTemplates[0];

        const prevComp = prevTpl?.Data?.[0];
        const newComp = newTpl?.Data?.[0];

        // no component to merge against, just take the new template as-is
        if (!prevComp || !newComp) return newTemplates;

        const mergedItems = mergeItemsById(prevComp.items, newComp.items);

        return [
            {
                ...prevTpl, ...newTpl,
                Data: [
                    {
                        ...prevComp,
                        ...newComp,
                        items: mergedItems,
                    }
                ]
            }
        ];
    };
    const handleSaveAIEncounter = (data, jobId) => {
        if (!isNull(data)) {
            const mergedMainCustomTemplate = mergeMainCustomTemplate(mainCustomTemplateData, data?.MainCustomTemplate)
            setAIEncounterData({ ...data, MainCustomTemplate: mergedMainCustomTemplate })
        }
        setClinicalAINoteJobsID(jobId || null);
    }
    const handleSetResponse = (response) => {
        console.log("ToSaveDataAI setEncounterData", response)
        setSearchParam(prev => ({
            ...prev,
            "EncounterType": response?.Data?.EncounterType,
            "NoteType": response?.Data?.NoteType,
            "EncounterDate": response?.Data?.EncounterDate,
            "SeenBy": response?.Data?.SeenBy,
            "Facility": response?.Data?.Facility,
            "EncounterStatus": response?.Data?.EncounterStatus,
            "VitalUnitType": response?.Data?.VitalUnitType,
            "PatientAppointmentID": response?.Data?.PatientAppointmentID,
        }));
        setEncounterData(prev => ({
            ...prev,
            ...response,
            Data: { ...prev?.Data, ...response?.Data }
        }));
        setMainCustomTemplateData(response?.MainCustomTemplate || [])
        setCustomTemplateData(response?.CustomTemplate || [])
        let { TableName, ...qocData } = response.QualityOfCare;
        setSaveQualityOfCareData(prev => ({ ...prev, ...qocData }));

        setShowPreview(["Signed", "To Be Co-Signed"].includes(response?.Data?.EncounterStatus) || !isEditAllowed);
        setSearchValue(prev => ({
            ...prev,
            "EncounterType": DropdownValueHandler(visitTypes, response?.Data?.EncounterType),
            "NoteType": DropdownValueHandler(noteTypes, response?.Data?.NoteType),
            "SeenBy": DropdownValueHandler(providerDD, response?.Data?.SeenBy),
            "Facility": DropdownValueHandler(locationDD, response?.Data?.Facility),
            "EncounterStatus": DropdownValueHandler(encounterStatus, response?.Data?.EncounterStatus) || "",
            "PatientAppointmentID": response?.Data?.PatientAppointmentID ? response?.Data?.EncounterDate : "",
        }));
        setSaveTrigger({ [response?.Data?.NoteType || 'CustomNote']: false })
        setIsProcedureEdit(response?.SuperBill?.length > 0 ? false : true)
        setAIEncounterData(null)
        setTimeout(() => {
            getSaveData()
        }, 0)
    }
    return (
        <>
            {isLoading ? <Loader /> : null}
            {encounterExistConfirmation}
            <EncounterDetails ref={childRef} is={is} setIs={setIs}
                handleSaveAIEncounter={handleSaveAIEncounter}
                defaultSelectedItems={defaultSelectedItems} setDefaultSelectedItems={setDefaultSelectedItems} setSelectedItems={setSelectedItems}
                insertPosition={insertPosition}
                customTemplateData={customTemplateData} setCustomTemplateData={setCustomTemplateData}
                setSaveCustomTemplateData={setSaveCustomTemplateData}
                handleSetDefaultItemsForValidation={handleSetDefaultItemsForValidation}
                mainCustomTemplateData={mainCustomTemplateData}
                hasInitializedAIProcessing={hasInitializedAIProcessing}
                //  setMainCustomTemplateData={setMainCustomTemplateData}
                // setSaveMainCustomTemplateData={setSaveMainCustomTemplateData}
                // handleSetDefaultItemsForValidationMain={handleSetDefaultItemsForValidationMain}

                saveAddendumData={saveAddendumData} setSaveAddendumData={setSaveAddendumData} searchParam={searchParam} setSearchParam={setSearchParam} searchValue={searchValue} setSearchValue={setSearchValue} providerDD={providerDD} locationDD={locationDD} setSaveTrigger={setSaveTrigger} initialData={encounterData}
                setEncounterData={setEncounterData}
                setShowPreview={setShowPreview} showPreview={showPreview} setReloadAfterSave={setReloadAfterSave}
                printoutSelectDataModal={printoutSelectDataModal} setPrintoutSelectDataModal={setPrintoutSelectDataModal} setIsProcedureEdit={setIsProcedureEdit} scrollTo={props?.scrollTo} setScrollTo={props?.setScrollTo} handleNoteTypeChange={props?.handleNoteTypeChange} patientID={patientID} encounterID={encounterID} mainServiceLineModal={mainServiceLineModal} isCustomNote={"true"} setSaveEncounterCoSignData={setSaveEncounterCoSignData} />
            <div className="ar-encounter-detail-content">
                <div className="d-flex gap-10 ">
                    {showPreview ? null :
                        <div className="h-100 ar-side-line d-flex flex-column gap-5">
                            <div className="ar-icon d-flex align-items-center justify-content-center"
                                onMouseDown={() => startScrolling("up")}
                                onMouseUp={stopScrolling}
                                onMouseLeave={stopScrolling}>
                                <i className="icon-up fs-10"></i>
                            </div>
                            <div className="d-flex flex-column gap-5 options-scroll" ref={scrollableDivRef}>
                                <SectionScrollNavigator encounterID={encounterID} activeID={activeID} setActiveID={setActiveID} hoveredItem={hoveredItem} setHoveredItem={setHoveredItem} defaultSelectedItems={defaultSelectedItems} mainCustomTemplateData={mainCustomTemplateData} customTemplateData={customTemplateData} />
                            </div>
                            <div className="ar-icon d-flex align-items-center justify-content-center"
                                onMouseDown={() => startScrolling("down")}
                                onMouseUp={stopScrolling}
                                onMouseLeave={stopScrolling}>
                                <i className="icon-down fs-10"></i>
                            </div>
                        </div>}
                    <div className="w-100 pt-1-5 hover-scrollbar scroll pe-1-5">
                        {/* Custom Note */}
                        {/* {console.log("searchParamNoteType", searchParam?.NoteType)} */}
                        {searchParam.NoteType === customNoteType &&
                            <CustomNote
                                ref={childCustomNoteRef}
                                encounterID={encounterID}
                                key={encounterData?.Data?.EncounterID}
                                saveEncounterCoSignData={saveEncounterCoSignData}
                                saveAddendumData={saveAddendumData}
                                saveQualityOfCareData={saveQualityOfCareData}
                                setSaveQualityOfCareData={setSaveQualityOfCareData}
                                setAccordions={setAccordions}
                                initialData={encounterData}
                                saveSignal={saveTrigger?.[customNoteType]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                onSave={onSave}
                                setActiveID={setActiveID}
                                setHoveredItem={setHoveredItem}
                                isRecordSaved={props?.isRecordSaved}
                                isRecordSavedType={props?.isRecordSavedType}
                                showPreview={showPreview}
                                searchValue={searchValue}
                                patientID={patientID}
                                isProcedureEdit={isProcedureEdit}
                                setIsProcedureEdit={setIsProcedureEdit}
                                printoutSelectDataModal={printoutSelectDataModal}
                                setPrintoutSelectDataModal={setPrintoutSelectDataModal}
                                printoutModal={printoutModal}
                                setPrintoutModal={setPrintoutModal}
                                getSaveData={getSaveData}
                                setReloadAfterSave={setReloadAfterSave}
                                mainServiceLineModal={mainServiceLineModal}
                                setMainServiceLineModal={setMainServiceLineModal}
                                defaultSelectedItems={defaultSelectedItems}
                                selectedItems={selectedItems}
                                setSelectedItems={setSelectedItems}

                                insertPosition={insertPosition}
                                customTemplateData={customTemplateData}
                                setCustomTemplateData={setCustomTemplateData}

                                saveCustomTemplateData={saveCustomTemplateData}
                                setSaveCustomTemplateData={setSaveCustomTemplateData}
                                validations={validationItemsModal}
                                // Main //
                                mainCustomTemplateData={mainCustomTemplateData}
                                setMainCustomTemplateData={setMainCustomTemplateData}
                                saveMainCustomTemplateData={saveMainCustomTemplateData}
                                setSaveMainCustomTemplateData={setSaveMainCustomTemplateData}
                                validationItemsModalMain={validationItemsModalMain}
                                aiEncounterData={aiEncounterData}
                                handleSetResponse={handleSetResponse}
                            />
                        }

                    </div>
                </div>
                {showPreview ? null :
                    <div className='tabs-action-bottom br-top-1 br-bottom-1 align-items-center justify-content-between d-flex br-clr mx-0 position-static z-unset px-1 h-100 py-1 px-2'>
                        <div className="">
                            <p className='heading heading_ext d-flex align-items-center gap-01'>Updated By/Date: <span className='text text_color'>{encounterData?.Data?.UpdatedBy || 'N/A'}, {encounterData?.Data?.UpdateDate || 'N/A'}</span></p>
                        </div>
                        <div className="">
                            <button className={`btn btn-orange ${isEditAllowed ? '' : 'disabled'}`} onClick={getSaveData}>Save</button>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}

export default CustomNotewithDetails